import { styled } from '@linaria/react';
import { space } from '../../theme/tokens';

export const GuestList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
  padding-bottom: ${space[4]};
`;
